import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Store, Handshake, Boxes, LogOut } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useLang();
  const loc = useLocation();
  const navigate = useNavigate();

  const NAV = [
    { to: "/dashboard", label: t("nav.developer"), icon: LayoutDashboard, id: "nav-dashboard" },
    { to: "/market", label: t("nav.market"), icon: Store, id: "nav-market" },
    { to: "/seller", label: t("nav.seller"), icon: Handshake, id: "nav-seller" },
    { to: "/modules", label: t("nav.modules"), icon: Boxes, id: "nav-modules" },
  ];

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-[#05050A]/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => {
            const active = loc.pathname === n.to;
            const Icon = n.icon;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={n.id}
                className={`flex items-center gap-2 px-4 py-2 font-mono text-xs uppercase tracking-wider border-b-2 transition-colors ${
                  active ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
                }`}
              >
                <Icon className="w-4 h-4" /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-3">
          {/* Language switch */}
          <div className="flex border border-border" data-testid="lang-switch">
            {["it", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                className={`px-2.5 py-1 font-mono text-[11px] uppercase transition-colors ${
                  lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <div className="text-right hidden sm:block">
            <div className="text-xs font-semibold text-foreground">{user?.name}</div>
            <div className="font-mono text-[10px] uppercase text-primary/70 tracking-wider">{user?.role}</div>
          </div>
          <Button
            data-testid="logout-btn"
            variant="outline"
            size="icon"
            title={t("nav.logout")}
            className="rounded-none border-border hover:border-primary hover:text-primary"
            onClick={async () => { await logout(); navigate("/login"); }}
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
